

export const drawerWidth = 280;
export const BASE_URL = 'https://api-i4.digama.com.br';
//export const BASE_URL = 'http://localhost:3105';
//export const BASE_URL = 'http://localhost:8081/';
//export const BASE_URL = 'http://25.55.41.122:3100/';
//export const BASE_URL = 'http://192.168.1.102:3100';
//export const BASE_URL = 'http://10.1.20.16:3100';
export const TITLE = 'i4';

export const VERSAO = '4.0.121';

//TODO: alterar para state.auth.defaultTentant  para ajustar imagem com state
export const getTntFolder = () => {
    // const state = store.getState();
    return "tnt"+ (localStorage.getItem('tenantFolder') !== null )? localStorage.getItem('tenantFolder') : '0';
}


